/* Product-page interactions are scoped to the approved purchase layout. */
(() => {
  const root = document.getElementById('owl-product');
  if (!root) return;
  const image = root.querySelector('#preview-image');
  const galleryButtons = root.querySelectorAll('[data-owl-image]');
  const showImage = (url, alt) => {
    if (!image || !url) return;
    image.src = url;
    image.alt = alt;
    galleryButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.owlImage === url)));
  };
  galleryButtons.forEach(button => button.addEventListener('click', () => {
    showImage(button.dataset.owlImage, button.dataset.imageAlt);
  }));
  const variants = root.querySelectorAll('[data-owl-variant]');
  const form = root.querySelector('#AddToCartForm');
  const availability = root.querySelector('.owl-availability');
  const stockHelp = root.querySelector('.owl-stock-help');
  const syncAvailability = () => {
    const selected = root.querySelector('[data-owl-variant][aria-pressed="true"]');
    if (!selected) return;
    const available = selected.dataset.available === 'true';
    const inStock = available && Number(selected.dataset.inventoryQuantity) > 0;
    // Observe Amai's actual rendered control, not inventory or its private settings.
    const preorder = Array.from(form.querySelectorAll('[data-pre-order-atc-button="1"]')).some(button => {
      const style = window.getComputedStyle(button);
      return !button.disabled && button.getClientRects().length > 0 && style.visibility !== 'hidden';
    });
    const state = preorder ? 'preorder' : !available ? 'sold-out' : inStock ? 'in-stock' : 'available';
    const label = preorder ? 'Available for pre-order' : !available ? 'Sold out' : inStock ? 'In stock' : 'Available to order';
    // Only write when changed: Amai and this observer both watch the form.
    if (availability.dataset.state !== state) availability.dataset.state = state;
    const text = availability.querySelector('.owl-availability-label');
    if (text.textContent !== label) text.textContent = label;
    const hideHelp = available || preorder;
    if (stockHelp.hidden !== hideHelp) stockHelp.hidden = hideHelp;
  };
  variants.forEach(button => button.addEventListener('click', () => {
    const data = button.dataset;
    variants.forEach(variant => variant.setAttribute('aria-pressed', String(variant === button)));
    const variantInput = root.querySelector('#product-variant-id');
    variantInput.value = data.owlVariant;
    variantInput.setAttribute('value', data.owlVariant);
    root.querySelector('#owl-selected-finish').textContent = data.title;
    root.querySelector('.owl-price').textContent = data.price;
    const compare = root.querySelector('.owl-compare-price');
    compare.textContent = data.comparePrice;
    compare.hidden = !data.comparePrice;
    const savings = root.querySelector('.owl-savings');
    if (savings) {
      savings.textContent = data.savings || '';
      savings.hidden = !data.savings;
    }
    const available = data.available === 'true';
    const cartButton = root.querySelector('.owl-add-to-cart');
    if (cartButton) {
      cartButton.disabled = !available;
      cartButton.textContent = available ? 'Add to cart' : 'Sold out';
    }
    showImage(data.image, data.imageAlt);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', data.owlVariant);
    window.history.replaceState(null, '', url);
    // Let Amai re-evaluate its own rules and update its own purchase control.
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    syncAvailability();
  }));
  const availabilityObserver = new MutationObserver(syncAvailability);
  availabilityObserver.observe(form, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'disabled', 'data-pre-order-atc-button']
  });
  window.addEventListener('resize', syncAvailability);
  window.addEventListener('load', syncAvailability, { once: true });
  syncAvailability();
  const quantity = root.querySelector('#quantity');
  root.querySelectorAll('[data-owl-quantity]').forEach(button => button.addEventListener('click', () => {
    const current = Number.parseInt(quantity.value, 10) || 1;
    quantity.value = Math.max(1, Math.min(1000, current + Number(button.dataset.owlQuantity)));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const tabList = root.querySelector('.owl-product-tabs');
  const links = Array.from(tabList.querySelectorAll('a'));
  const panelContainer = root.querySelector('.owl-tab-panels');
  const panels = links.map(link => root.querySelector(link.hash));
  tabList.setAttribute('role', 'tablist');
  links.forEach((link, index) => {
    link.id = `${panels[index].id}-tab`;
    link.setAttribute('role', 'tab');
    link.setAttribute('aria-controls', panels[index].id);
    link.removeAttribute('aria-current');
    panels[index].setAttribute('role', 'tabpanel');
    panels[index].setAttribute('aria-labelledby', link.id);
    panels[index].tabIndex = 0;
  });
  const selectTab = (index, updateUrl = false) => {
    const scrollPosition = window.scrollY;
    links.forEach((link, i) => {
      link.setAttribute('aria-selected', String(i === index));
      link.tabIndex = i === index ? 0 : -1;
      panels[i].hidden = i !== index;
    });
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.hash = links[index].hash;
      window.history.replaceState(null, '', url);
      // Flush the new layout before restoring the viewport; theme/app styles may
      // otherwise anchor to a descendant or the footer as panels are hidden.
      panelContainer.getBoundingClientRect();
      window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    }
  };
  const indexForHash = hash => ['#owl-delivery', '#owl-warranty'].includes(hash) ? 2 : links.findIndex(link => link.hash === hash);
  links.forEach((link, index) => {
    link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      selectTab(index, true);
    });
    link.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % links.length;
      else if (event.key === 'ArrowLeft') next = (index + links.length - 1) % links.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = links.length - 1;
      else if (event.key === ' ') next = index;
      else return;
      event.preventDefault();
      selectTab(next, true);
      links[next].focus({ preventScroll: true });
      const bounds = links[next].getBoundingClientRect();
      const listBounds = tabList.getBoundingClientRect();
      if (bounds.right > listBounds.right) tabList.scrollLeft += bounds.right - listBounds.right;
      if (bounds.left < listBounds.left) tabList.scrollLeft -= listBounds.left - bounds.left;
    });
  });
  // Purchase-area shortcuts open the relevant panel and intentionally bring it into view.
  root.querySelectorAll('.owl-purchase-links a, .owl-compatibility-link, .owl-order-details a').forEach(link => link.addEventListener('click', event => {
    const index = indexForHash(link.hash);
    if (index < 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    selectTab(index, true);
    tabList.scrollIntoView({ block: 'start' });
  }));
  window.addEventListener('hashchange', () => {
    const index = indexForHash(window.location.hash);
    if (index >= 0) selectTab(index);
  });
  selectTab(Math.max(0, indexForHash(window.location.hash)));
})();
